module.exports = __webpack_public_path__ + "static/dark-text-bg-long-0ed88782e7ff0a2214809257104b4a4a.png";